import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

function getStrapiApiBaseUrlSafe() {
	const raw = import.meta.env.VITE_STRAPI_URL?.trim();
	if (!raw) return "";

	const normalized = raw.replace(/\/$/, "");

	try {
		const parsed = new URL(normalized);
		if (parsed.pathname === "/api") return `${parsed.origin}/api`;
		if (parsed.pathname === "" || parsed.pathname === "/") return `${parsed.origin}/api`;
		return normalized;
	} catch {
		return normalized.endsWith("/api") ? normalized : `${normalized}/api`;
	}
}

export const strapiApiSlice = createApi({
	reducerPath: "strapiApi",
	baseQuery: fetchBaseQuery({
		baseUrl: getStrapiApiBaseUrlSafe(),
		prepareHeaders: (headers) => {
			const token = import.meta.env.VITE_STRAPI_API_TOKEN?.trim();
			if (token) headers.set("authorization", `Bearer ${token}`);
			headers.set("accept", "application/json");
			return headers;
		},
	}),
	endpoints: (builder) => ({}),
});

